import React, { ReactNode, useMemo } from 'react'
import { useFragment } from 'react-relay'
import { useLocation } from 'react-router-dom'
import { graphql } from 'relay-runtime'
import { PurposelyLogo } from '../../components/icons/PurposelyLogo'
import { GlobalSearch } from '../../features/insights_hub/components/GlobalSearch/GlobalSearch'
import { ROUTES } from '../../routes'

import { Sidebar } from '../Sidebar/Sidebar'
import { Layout_User$key } from './__generated__/Layout_User.graphql'

const Layout_User = graphql`
  fragment Layout_User on User {
    id
    ...Sidebar_User
  }
`

interface LayoutProps {
  fragmentKey: Layout_User$key
  children: ReactNode
}
export const Layout = ({ children, fragmentKey }: LayoutProps) => {
  const data = useFragment(Layout_User, fragmentKey)
  const location = useLocation()

  const routeConfig = useMemo(() => {
    return Object.values(ROUTES).find((r) => r.path === location.pathname)
  }, [location.pathname])

  return (
    <div className="flex h-screen w-screen">
      <aside className="h-full flex-none">
        <Sidebar fragmentKey={data} />
      </aside>

      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <nav className="z-20 w-full flex-none px-6 py-4 shadow-md">
          <div className="flex items-center justify-between">
            <PurposelyLogo />
            {routeConfig?.searchEnabled && <GlobalSearch />}
          </div>
        </nav>

        <main className="mx-auto w-full flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  )
}
